import { L } from "./i18n";
// Mock data for R&H Lawyers LLP — Cash & Savings Platform (Insignis-style clone)
// NOTE: All data below is MOCK data for a frontend-only teaser. No sensitive
// personal/banking data (passport, account numbers, IBAN) is exposed here.

const company__raw = {
  name: "R&H Lawyers LLP",
  brandMark: "R&H",
  brandSub: "SAVINGS",
  legalName: "R&H Lawyers LLP",
  registration: "OC415660",
  sraFirm: "656816",
  regulator: "Solicitors Regulation Authority (SRA)",
  incorporated: "27 January 2017",
  legalForm: "Limited Liability Partnership",
  representedBy: "Xiaoxia He",
  address: "3rd Floor, 9 St. Clare Street, City of London, London, EC3N 1LQ, United Kingdom",
  email: "info@randhadvisory.com",
  phone: "+44 (0)20 7946 0321",
  phoneDE: "+49 30 46690243",
  phoneDENote: "Region Germany – for German-speaking clients",
  interestRate: 0.0466, // 4.66% illustrative gross AER
};

const announcement__raw = {
  text: "UK businesses lose 5+ weeks a year to banking admin. There's a better way.",
  cta: "Download the report",
};

const hero__raw = {
  eyebrow: "Cash management for a demanding world",
  title: "Don't just hold it.",
  titleAccent: "Grow it.",
  subtitle:
    "Increase returns on your cash deposits and spread risk with access to 55+ banks and building societies on one elegant platform.",
  secondaryCta: "Request an illustration",
  badges: [
    { label: "FSCS protection on", strong: "eligible deposits" },
    { label: "55+ Banks and", strong: "Building Societies" },
    { label: "SRA regulated", strong: "trusted stewardship" },
  ],
  image:
    "https://images.unsplash.com/photo-1654292541857-9d5a6d8f3ef3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxMb25kb24lMjBmaW5hbmNpYWx8ZW58MHx8fHwxNzgyNzc0ODMyfDA&ixlib=rb-4.1.0&q=85",
};

const banks__raw = [
  "Santander International",
  "Nationwide",
  "Aldermore",
  "Investec",
  "Close Brothers Savings",
  "Al Rayan Bank",
  "OakNorth",
  "The Cambridge Building Society",
  "BLME",
  "Société Générale",
  "HSBC UK",
  "Barclays",
];

const solutions__raw = [
  {
    id: "business",
    title: "Business",
    body: "Reduce risk and access market-leading rates for your capital with one application.",
    link: "Protect and grow capital",
  },
  {
    id: "personal",
    title: "Personal",
    body: "Never lose sight of interest earned again by bringing your savings together in one place.",
    link: "Get more from your savings",
  },
  {
    id: "charities",
    title: "Charities & Schools",
    body: "See how much further your funding can go with the right savings strategy.",
    link: "Earn your organisation interest",
  },
  {
    id: "accountants",
    title: "Accountants",
    body: "Strengthen client relationships by supporting your clients' growth.",
    link: "Grow your clients' assets",
  },
  {
    id: "advisers",
    title: "Advisers",
    body: "Secure your clients' cash and help them capitalise on their savings.",
    link: "Support your clients' savings",
  },
];

const steps__raw = [
  {
    n: "01",
    title: "Submit an application",
    body: "Fill in and submit a single application form to join R&H Savings.",
  },
  {
    n: "02",
    title: "Access savings products",
    body: "Choose from thousands of savings products from 55+ banks and building societies.",
  },
  {
    n: "03",
    title: "Place funds",
    body: "Place funds as often as required. Withdraw money from the platform at any time.",
  },
];

const testimonialTabs__raw = [
  {
    id: "individuals",
    label: "Individuals",
    items: [
      {
        quote:
          "Having access to so many banks, all covered by the FSCS, has removed the pressure of constantly chasing the best rate. Everything in one place has been a genuine game-changer.",
        name: "Katherine S.",
        role: "R&H Client",
      },
      {
        quote:
          "The platform is tremendously easy to use and there is clear information about every product. I would recommend R&H without hesitation.",
        name: "John W.",
        role: "R&H Client",
      },
    ],
  },
  {
    id: "advisers",
    label: "Advisers",
    items: [
      {
        quote:
          "Too many clients miss the low-hanging fruit of earning more on their cash. With R&H it's remarkably easy to access better rates and diversify counterparty risk.",
        name: "Peter K.",
        role: "Chartered Financial Planner",
      },
    ],
  },
  {
    id: "business",
    label: "Business",
    items: [
      {
        quote:
          "Before R&H we spent a great deal of time on forms and researching where to place funds. Now we place funds in minutes, with access to the best rates available.",
        name: "Ross H.",
        role: "Finance Controller",
      },
      {
        quote:
          "A wide array of institutions and rates, sometimes more competitive than our own banks quote us directly. The self-serve element is supported by a very responsive team.",
        name: "Kirsty L.",
        role: "Finance Director",
      },
    ],
  },
  {
    id: "charities",
    label: "Charities & Education",
    items: [
      {
        quote:
          "The personal help we received when choosing providers was invaluable. Applying with a single form and the ease of transferring money made the whole process straightforward.",
        name: "Peter R.",
        role: "Charity CEO",
      },
    ],
  },
  {
    id: "accountants",
    label: "Accountants",
    items: [
      {
        quote:
          "We've referred many clients to R&H. The onboarding is seamless and we have a dedicated point of contact. Their rates are competitive and add real value.",
        name: "Paula W.",
        role: "Partner, Accountancy Practice",
      },
    ],
  },
];

const faqs__raw = [
  {
    q: "How is the interest I receive calculated?",
    a: "Interest is calculated by each individual bank or building society on the balance held with them, at the gross rate applicable to the chosen product. It is typically paid at maturity or on a monthly/annual basis depending on the product. Your consolidated statement shows a blended average across all your holdings.",
  },
  {
    q: "What are the firm's incorporation details?",
    a: "R&H Lawyers LLP is a Limited Liability Partnership incorporated in England and Wales (Registration No. OC415660) with its registered office at 3rd Floor, 9 St. Clare Street, City of London, London, EC3N 1LQ. The firm is regulated by the Solicitors Regulation Authority (SRA Firm No. 656816).",
  },
  {
    q: "What types of accounts are available?",
    a: "The platform offers instant-access, notice and fixed-term deposit accounts across our panel of 55+ banks and building societies, in GBP and selected foreign currencies. Availability varies by client type and deposit size.",
  },
  {
    q: "What account authority models are supported on the platform?",
    a: "We support single, joint, and multi-signatory authority models, including dual authorisation for businesses, charities and trusts. Permissions can be tailored so that viewers, initiators and approvers each have appropriate access.",
  },
];

const insights__raw = [
  {
    tag: "News",
    title:
      "Bank of England holds base rate again: what it means for savers and businesses",
    date: "July 30, 2026",
    excerpt:
      "With the base rate held once more against a backdrop of market volatility, a hold is still a good moment to check whether your cash is working as hard as it should be.",
    image:
      "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxiYW5raW5nfGVufDB8fHx8MTc4ODQ2MTkyOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Security",
    title: "Fraudsters are targeting financial firms: how R&H keeps clients safe",
    date: "August 20, 2026",
    excerpt:
      "A look at the layered controls, verification and monitoring we use to protect client funds and identities across the platform.",
    image:
      "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGZpbmFuY2V8ZW58MHx8fHwxNzg4NDYxOTI4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Charity",
    title: "How savings platforms help UK trusts manage cash",
    date: "August 19, 2026",
    excerpt:
      "Trustees have a duty to steward funds carefully. We explore how a diversified savings strategy can stretch funding further.",
    image:
      "https://images.pexels.com/photos/6801680/pexels-photo-6801680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "Business",
    title: "What is a cash savings platform? A guide for UK businesses",
    date: "August 18, 2026",
    excerpt:
      "From one application to hundreds of products, we break down how a cash savings platform simplifies treasury management.",
    image:
      "https://images.unsplash.com/photo-1462556791646-c201b8241a94",
  },
];

const navMenu__raw = [
  {
    label: "Solutions",
    items: [
      { label: "Business", to: "/solutions/business" },
      { label: "Personal", to: "/solutions/personal" },
      { label: "Charities & Schools", to: "/solutions/charities" },
      { label: "Accountants", to: "/solutions/accountants" },
      { label: "Advisers", to: "/solutions/advisers" },
    ],
  },
  { label: "How it works", anchor: "how-it-works" },
  { label: "Calculator", anchor: "calculator" },
  { label: "UK Fixed Deposits", to: "/uk-fixed-deposits" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const company = L(company__raw);
export const announcement = L(announcement__raw);
export const hero = L(hero__raw);
export const banks = L(banks__raw);
export const solutions = L(solutions__raw);
export const steps = L(steps__raw);
export const testimonialTabs = L(testimonialTabs__raw);
export const faqs = L(faqs__raw);
export const insights = L(insights__raw);
export const navMenu = L(navMenu__raw);
